module.exports = __webpack_public_path__ + "img/round-tick.be943a0c.svg";